module.exports = __webpack_public_path__ + "static/media/Outlook-WK.18c1949e.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/Outlook-WK.jpg
// module id = 1541
// module chunks = 1